import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-appendage-dashboard',
  templateUrl: './appendage-dashboard.component.html',
  styleUrls: ['./appendage-dashboard.component.scss']
})
export class AppendageDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
